import { useMemo, useState } from "react";
import type { Answers } from "@/schema/quizSchema";
import { resolveReport } from "../resolver";
import { toWaterView } from "../view";
import type { Severity } from "../profiles";
import reportCss from "../report.tokens.css?inline";
import { ResultPage1 } from "./ResultPage1";
import { ResultPage2 } from "./ResultPage2";

export function AuralWaterReport({
  answers,
  severity,
  trackCta,
}: {
  answers: Answers;
  severity: Severity;
  trackCta?: () => void;
}) {
  const rawCp = typeof answers.q_cp === "string" ? answers.q_cp : "";
  const view = useMemo(() => toWaterView(resolveReport(rawCp), rawCp), [rawCp]);
  const [page, setPage] = useState<1 | 2>(1);

  return (
    <div className="qk-aural">
      {/* Scoped styles live inside the shadow root (this component renders within it). */}
      <style>{reportCss}</style>
      {page === 1 ? (
        <ResultPage1 view={view} severity={severity} answers={answers} onSeeSolution={() => setPage(2)} />
      ) : (
        <ResultPage2 profileKey={view.profile} onBack={() => setPage(1)} onCtaClick={trackCta} />
      )}
    </div>
  );
}
